let metaCounter: number = module.hot?.data?.metaCtr || 0;
let counterMap: Map<number, number> = module.hot?.data?.ctrs || new Map();
let nameMap: Map<string|Symbol, number> = module.hot?.data?.names || new Map();

module.hot?.accept();
module.hot?.addDisposeHandler((data: any) => {
    data.metaCtr = metaCounter;
    data.ctrs = counterMap;
    data.names = nameMap;
});


export type Counter = () => number;

function buildCounterForId(id: number): Counter {
    return () => {
        const value = counterMap.get(id)!;
        counterMap.set(id, value+1);
        return value;
    }
}


export function counter(start: number = 0): Counter {
    const myCounter = metaCounter++;
    counterMap.set(myCounter, start);
    return buildCounterForId(myCounter);
}

export function namedCounter(name: Symbol|string, start=0): Counter {
    const myId =
        nameMap.has(name)
        ? nameMap.get(name)!
        : metaCounter++;

    if (!nameMap.has(name)) {
        nameMap.set(name, myId);
    }
    if (!counterMap.has(myId)) {
        counterMap.set(myId, start);
    }

    return buildCounterForId(myId);
}
